import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { GetProductDetailResponse, OpenOrder } from "../../models/store.model";
import { useHistory } from "react-router-dom";
interface props {
  detailData: any;
  setInventoryId: any;
  inventoryId: any;
}
export default function ProductSpecifications({
  detailData,
  setInventoryId,
  inventoryId,
}: props) {
  let oldOrder = detailData.openOrders?.filter(
    (i: OpenOrder) => i.inventoryId == inventoryId
  );
  let notOldOrder = detailData.colorOptions?.filter(
    (i: OpenOrder) => i.inventoryId == inventoryId
  );
  let oldId =
    detailData.openOrders?.length > 0
      ? oldOrder && oldOrder.length > 0
        ? oldOrder[0]?.inventoryId
        : notOldOrder && notOldOrder.length > 0
        ? notOldOrder[0].inventoryId
        : detailData.openOrders[0]?.inventoryId
      : notOldOrder && notOldOrder.length > 0
      ? notOldOrder[0].inventoryId
      : detailData.colorOptions[0]?.inventoryId;
  let oldColor =
    detailData.openOrders?.length > 0
      ? oldOrder && oldOrder.length > 0
        ? oldOrder[0]?.colorTitle
        : notOldOrder && notOldOrder.length > 0
        ? notOldOrder[0].colorTitle
        : detailData.openOrders[0]?.colorTitle
      : notOldOrder && notOldOrder.length > 0
      ? notOldOrder[0].colorTitle
      : detailData.colorOptions[0]?.colorTitle;

  const [color, setColor] = React.useState(oldColor);
  const [active, setActive] = React.useState(oldId);

  const typeHandle = (index: number, inventoryId: number, color: string) => {
    setActive(inventoryId);
    setInventoryId(inventoryId);
    setColor(color);
  };
  const history = useHistory<{
    parentCategoryId: number;
    title: string;
  }>();
  const handleCategoryPath = (key: number, value: string) => {
    history.push({
      pathname: `/products/productCategory1/productCategoryCard/${key}`,
      state: {
        parentCategoryId: key,
        title: value,
      },
    });
  };
  return (
    <Grid container spacing={2} style={{ padding: "0 20px 0 15px" }}>
      <Grid item xs={12} style={{ color: "#64B5F6" }}>
        <b style={{ color: "gray" }}>{detailData.brand}</b>
        <>
          {detailData.categoryPath.map((path: any) => (
            <span
              className="cursorPointer fontMedium"
              onClick={() => handleCategoryPath(path.key, path.value)}
            >
              / {path.value}
            </span>
          ))}
        </>
      </Grid>
      <Grid item xs={12} style={{ color: "#1D4A87", fontSize: "1.3rem" }}>
        <b>{detailData.title}</b>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ color: "#BDBDBD" }}
        // className="lineAfterEnglishName"
      >
        {detailData.englishTitle}
      </Grid>
      <Grid item xs={12} sx={{ fontSize: "1.2rem", marginTop: "10px" }}>
        <span className="fontWeight">
          رنگ کالا: {oldColor ? oldColor : color}
        </span>
      </Grid>

      <Grid item xs={6}>
        <div>
          {detailData.colorOptions?.map((item: any, index: number) => (
            <div
              className={
                item.inventoryId === (oldId ? oldId : active)
                  ? "colorCircle"
                  : "emptyCircle"
              }
              tabIndex={1}
              style={{
                textAlign: "center",
                verticalAlign: "top",
                writingMode: "vertical-rl",
                alignContent: "center",
                marginLeft: "10px",
              }}
              onClick={(e) =>
                typeHandle(index, item.inventoryId, item.colorTitle)
              }
            >
              <span
                // onClick={() => getColorTitle()}
                className="dot"
                style={{
                  backgroundColor: item.colorCode,
                  verticalAlign: "top",
                }}
              ></span>
            </div>
          ))}
        </div>
      </Grid>
      <Grid item xs={12}></Grid>
      <b style={{ marginTop: "20px" }} className="textFont16">
        مشخصات کالا
      </b>

      <Grid
        item
        xs={12}
        sx={{
          height: "fit-content",
          maxHeight: "55vh",
          overflowY: "auto",
        }}
        className="costumized-scrollBar"
      >
        <Grid
          container
          style={{ paddingRight: "10px", borderRight: "1px solid #E0E0E0" }}
        >
          {detailData.properties?.map((item: any, i: number) => (
            <Grid
              item
              xs={12}
              container
              style={{ paddingRight: "10px" }}
              sx={{
                marginTop: i !== 0 ? "10px" : "0px",
                marginBottom:
                  i !== detailData.properties.length - 1 ? "10px" : "0px",
              }}
            >
              <Grid item xs={3} style={{ color: "#757575" }}>
                {item.key}
              </Grid>
              <Grid item xs={9} style={{ color: "#424242" }}>
                <b> {item.value}</b>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
